"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var Button_1 = __importDefault(require("../Button"));
var trophies_1 = __importDefault(require("./trophies"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        title: {
            textAlign: 'center',
        },
        grid: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
        },
        item: {
            width: 112,
            height: 112,
            borderRadius: 8,
            textAlign: 'center',
            display: 'block',
            margin: 8,
            padding: 8,
        },
        buttonItem: {
            '&:hover': {
                backgroundColor: '#ECEFF1',
            },
        },
        image: {
            width: 60,
            imageRendering: 'pixelated',
        },
        imageGray: {
            opacity: 0.7,
        },
        name: {
            fontSize: '12px',
        },
        spacer: {
            width: 112,
            marginLeft: 8,
            marginRight: 8,
            paddingLeft: 8,
            paddingRight: 8,
        },
        buyButton: {
            paddingTop: 0,
            paddingBottom: 0,
            lineHeight: 1,
        },
    });
});
var PurchaseTrophiesDialog = function (_a) {
    var availableGold = _a.availableGold, purchasedTrophies = _a.purchasedTrophies, onClickClose = _a.onClickClose, onClickTrophy = _a.onClickTrophy, other = __rest(_a, ["availableGold", "purchasedTrophies", "onClickClose", "onClickTrophy"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement(core_1.Dialog, __assign({ fullWidth: true, maxWidth: "md" }, other),
        react_1.default.createElement(core_1.DialogTitle, { className: classes.title }, "Trophies"),
        react_1.default.createElement(core_1.DialogContent, { className: classes.grid },
            trophies_1.default.map(function (trophy) {
                return purchasedTrophies.includes(trophy.id) ? (react_1.default.createElement(core_1.ButtonBase, { className: clsx_1.default(classes.item, classes.buttonItem), onClick: function () { return onClickTrophy(trophy.id); } },
                    react_1.default.createElement("img", { alt: trophy.name, className: classes.image, src: "/images/trophies/" + trophy.id + ".png" }),
                    react_1.default.createElement(core_1.Typography, { className: classes.name }, trophy.name))) : (react_1.default.createElement("div", { className: classes.item },
                    react_1.default.createElement("img", { alt: trophy.name, className: clsx_1.default(classes.image, classes.imageGray), src: "/images/trophies/" + trophy.id + "-mono.png" }),
                    react_1.default.createElement(Button_1.default, { size: "small", variant: "text", color: "primary", onClick: function () { return onClickTrophy(trophy.id); }, className: classes.buyButton }, "Buy")));
            }),
            react_1.default.createElement("div", { className: classes.spacer }),
            react_1.default.createElement("div", { className: classes.spacer }),
            react_1.default.createElement("div", { className: classes.spacer }),
            react_1.default.createElement("div", { className: classes.spacer })),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(Button_1.default, { variant: "text", onClick: onClickClose }, "Close"))));
};
exports.default = PurchaseTrophiesDialog;
//# sourceMappingURL=PurchaseTrophiesDialog.js.map